import React from 'react'
import { useField } from 'formik'
import PropTypes from 'prop-types'
import { Badge, FormFeedback, FormGroup, FormText, Input, Label } from 'reactstrap'
import { formatThousandsInput, sanitizeThousandsInput } from 'utils/thousands-input-util'

const propTypes = {
  id                 : PropTypes.string,
  name               : PropTypes.string.isRequired,
  label              : PropTypes.string,
  placeholder        : PropTypes.string,
  formText           : PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  formGroupClassName : PropTypes.string,
  labelClassName     : PropTypes.string,
  required           : PropTypes.bool,
  disabled           : PropTypes.bool,
  onChange           : PropTypes.func
}

const defaultProps = {
  labelClassName: 'text-gray-light text-capitalize'
}

const ThousandsInputField = ({
  id,
  name,
  label,
  placeholder,
  formText,
  formGroupClassName,
  labelClassName,
  required,
  disabled,
  onChange,
  ...props
}) => {
  const [ field, meta, helpers ] = useField(name)
  const valid = meta.touched && !meta.error
  const invalid = meta.touched && !!meta.error

  const handleChange = (event) => {
    const rawValue = sanitizeThousandsInput(event.target.value)

    helpers.setValue(rawValue)

    if (onChange) onChange(rawValue, event)
  }

  return (
    <FormGroup className={ formGroupClassName }>
      { label && (
        <Label for={ id || name } className={ labelClassName }>
          <strong>{ label }</strong>
        </Label>
      ) }
      { required && <Badge color='warning' className='ml-1'><i className='fas fa-asterisk' /></Badge> }
      <Input
        { ...props }
        id={ id || name }
        name={ name }
        type='text'
        inputMode='numeric'
        autoComplete='off'
        placeholder={ placeholder }
        disabled={ disabled }
        valid={ valid }
        invalid={ invalid }
        value={ formatThousandsInput(field.value) }
        onChange={ handleChange }
        onBlur={ field.onBlur }
      />
      { meta.error && <FormFeedback>{ meta.error }</FormFeedback> }
      { formText && <FormText>{ formText }</FormText> }
    </FormGroup>
  )
}

ThousandsInputField.propTypes = propTypes
ThousandsInputField.defaultProps = defaultProps

export default ThousandsInputField
